import { AuthLayout } from '@/modules/auth/ui/components'
import { LoadingSpinner } from '@/shared/ui/components'

export function LoadingState() {
  return (
    <AuthLayout title="Loading Invitation" subtitle="Verifying your invitation…">
      <div
        data-testid="join-loading"
        className="flex flex-col items-center justify-center gap-3 py-6"
      >
        <LoadingSpinner size="lg" color="white" />
      </div>
    </AuthLayout>
  )
}
